import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCart } from '@/context/CartContext';
import { useSettings } from '@/context/SettingsContext';
import { BACKEND_URL } from '@/lib/api';

export const Header = () => {
  const { totalItems, setIsOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { settings: s, settingsLoaded } = useSettings();
  const location = useLocation();

  // Hide header on admin pages and supplier release page
  if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/lieferanten-freigabe')) return null;

  const logo = s.logo_url;
  const subtitle = s.header_subtitle || '';
  const navHome = s.nav_home || '';
  const navProducts = s.nav_products || '';
  const navFaq = s.nav_faq || '';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-100 shadow-sm" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
            {logo ? (
              <img src={logo.startsWith('/api') ? `${BACKEND_URL}${logo}` : logo} alt="GB Sylt" className="h-10 object-contain" />
            ) : (
              <span className="text-xl font-bold text-[#0E518D] tracking-tight">GB Sylt</span>
            )}
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-medium text-slate-700 hover:text-[#0E518D] transition-colors uppercase tracking-wide" data-testid="nav-home">
              {navHome}
            </Link>
            <a href="#produkte" className="text-sm font-medium text-slate-700 hover:text-[#0E518D] transition-colors uppercase tracking-wide" data-testid="nav-products">
              {navProducts}
            </a>
            <a href="#faq" className="text-sm font-medium text-slate-700 hover:text-[#0E518D] transition-colors uppercase tracking-wide" data-testid="nav-faq">
              {navFaq}
            </a>
            <Button variant="ghost" size="sm" className="relative" onClick={() => setIsOpen(true)} data-testid="cart-button">
              <ShoppingBag className="h-5 w-5 text-[#0E518D]" />
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#D4AF37] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">{totalItems}</span>
              )}
            </Button>
          </nav>

          <div className="flex items-center gap-3 md:hidden">
            <Button variant="ghost" size="sm" className="relative" onClick={() => setIsOpen(true)} data-testid="cart-button-mobile">
              <ShoppingBag className="h-5 w-5 text-[#0E518D]" />
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#D4AF37] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">{totalItems}</span>
              )}
            </Button>
            <Button variant="ghost" size="sm" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
              {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-slate-100 pt-4 space-y-3">
            <Link to="/" onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-slate-700 uppercase tracking-wide py-2">{navHome}</Link>
            <a href="#produkte" onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-slate-700 uppercase tracking-wide py-2">{navProducts}</a>
            <a href="#faq" onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-slate-700 uppercase tracking-wide py-2">{navFaq}</a>
          </div>
        )}
      </div>
    </header>
  );
};
